import React, {
  useState, useEffect, useRef
} from 'react';
import {
  Box, Card, CardContent, CardHeader, Container, makeStyles, Divider, InputLabel,
  MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, Grid, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from 'react-alert';
import { Formik } from 'formik';
import * as Yup from 'yup';
import ReactToPrint from 'react-to-print';
import xlsx from 'json-as-xlsx';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import moment from 'moment';
import CreatePDF from './CreatePDF';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import services from '../Services';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'INVOICEPAYMENTHISTORYREPORT';

export default function InvoicePaymentHistoryReport() {
  const classes = useStyles();
  const [title] = useState('Invoice Payment History Report');
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isBalanceRateChangeEnabled: false
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: 0,
    factoryID: 0,
    supplierID: 0,
    date: new Date().toISOString().substring(0, 10)
  });
  const [totalAmount, setTotalAmount] = useState({
    amount: 0
  });
  const componentRef = useRef();
  const alert = useAlert();

  useEffect(() => {
    trackPromise(getPermissions());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    getFactoriesForDropDown();
  }, [selectedSearchValues.groupID]);

  useEffect(() => {
    trackPromise(
      getSupplierForDropdown()
    );
  }, [selectedSearchValues.factoryID]);

  async function getPermissions() {
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find((p) => p.permissionCode === 'VIEWINVOICEPAYMENTHISTORYREPORT');
    if (!isAuthorized) window.location.href = '/404';

    setPermissions({
      isGroupFilterEnabled: !!permissions.find((p) => p.permissionCode === 'GROUPDROPDOWN'),
      isFactoryFilterEnabled: !!permissions.find((p) => p.permissionCode === 'FACTORYDROPDOWN'),
    });

    setSelectedSearchValues((prev) => ({
      ...prev,
      groupID: parseInt(tokenService.getGroupIDFromToken()).toString(),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()).toString(),
    }));
  }

  async function getGroupsForDropdown() {
    const result = await services.getAllGroups();
    setGroups(result);
  }

  async function getFactoriesForDropDown() {
    const result = await services.getFactoryByGroupID(selectedSearchValues.groupID);
    setFactories(result);
  }

  async function getSupplierForDropdown() {
    const suppliers = await services.getSuppliersByGroupIDFactoryID(selectedSearchValues.groupID, selectedSearchValues.factoryID);
    setSupplierList(suppliers);
  }

  function calTotal(data) {
    let total = 0;
    data.forEach((element) => {
      total += parseFloat(element.amount);
    });
    setTotalAmount({
      amount: total
    });
  }

  const GetInvoicePaymentHistoryReport = async () => {
    const model = {
      groupID: parseInt(selectedSearchValues.groupID),
      factoryID: parseInt(selectedSearchValues.factoryID),
      date: selectedSearchValues.date,
      supplierID: parseInt(selectedSearchValues.supplierID)
    };
    const response = await services.GetInvoicePaymentHistoryReport(model);
    if (response.statusCode == 'Success' && response.data != null) {
      setTableData(response.data);
      calTotal(response.data);
      if (response.data.length == 0) {
        alert.error('No records to display');
      }
    }
  };

  function generateDropDownMenu(data) {
    const items = [];
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      });
    }
    return items;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setSelectedSearchValues((prev) => ({ ...prev, [name]: value }));
    setTableData([]);
    setPage(0);
  }

  const handleDateChange = (date) => {
    if (!date) return;
    setSelectedSearchValues((prev) => ({
      ...prev,
      date
    }));
    setTableData([]);
    setPage(0);
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>{titleName}</Grid>
      </Grid>
    );
  }

  async function createDataForExcel(array) {
    const res = [];
    if (array != null) {
      array.map((x) => {
        const vr = {
          'Invoice Number': x.voucherCode,
          'Ref Number': x.invoiceReference,
          'Supplier': x.supplierName,
          'Invoice Date': x.createdDate.split('T')[0],
          'Invoice Amount (Rs.)': x.amount,
          'Paid Amount (Rs.)': x.paidAmount,
          'Outstanding (Rs.)': Number(x.remainingAmount)
        };
        res.push(vr);
      });
      res.push({});
      var vr = {
        'Invoice Number': 'Total Amount :',
        'Invoice Amount (Rs.)': Number(totalAmount.amount)
      };
      res.push(vr);
      res.push({});
      var vr = {
        'Invoice Number': `Group Name :${groups[selectedSearchValues.groupID]}`,
        'Invoice Date': `Factory Name :${factories[selectedSearchValues.factoryID]}`,
      };
      res.push(vr);
      var vr = {
        'Invoice Number': `Date : ${moment(selectedSearchValues.date).format('DD/MM/YYYY')}`
      };
      res.push(vr);
    }
    return res;
  }
  async function createFile() {
    const file = await createDataForExcel(tableData);
    const settings = {
      sheetName: 'Invoice Payment History Report',
      fileName:
        `Invoice Payment History Report - ${groups[selectedSearchValues.groupID]} - ${factories[selectedSearchValues.factoryID]} - ${moment(selectedSearchValues.date).format('DD/MM/YYYY')}`,
      writeOptions: {}
    };
    const keys = file.length > 0 ? Object.keys(file[0]) : [];
    const tempcsvHeaders = [];
    keys.forEach((sitem) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    SetCsvHeaders(tempcsvHeaders);
    const dataA = [{
      sheet: 'Invoice Payment History Report',
      columns: tempcsvHeaders,
      content: file
    }];
    xlsx(dataA, settings);
  }

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
            layout:portrait
        }
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: selectedSearchValues.groupID,
              factoryID: selectedSearchValues.factoryID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min('1', 'Group is required'),
              factoryID: Yup.number().required('Estate is required').min('1', 'Estate is required'),
            })}
            onSubmit={GetInvoicePaymentHistoryReport}
            enableReinitialize
          >
            {({
              errors, handleBlur, handleSubmit, touched, setFieldTouched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={selectedSearchValues.groupID}
                              variant="outlined"
                              id="groupID"
                              size="small"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">Factory *</InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={selectedSearchValues.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size="small"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={8}>
                            <InputLabel shrink id="supplierID">
                              Supplier
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="supplierID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={selectedSearchValues.supplierID}
                              variant="outlined"
                              id="supplierID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Supplier--</MenuItem>
                              {generateDropDownMenu(supplierList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date"
                                name="date"
                                value={selectedSearchValues.date}
                                onChange={(date) => {
                                  handleDateChange(date);
                                  setFieldTouched('date', true, false);
                                }}
                                error={Boolean(touched.date && errors.date)}
                                helperText={touched.date && errors.date}
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size="small"
                          >
                            Search
                          </Button>
                        </Box>
                        <br />
                        <Box minWidth={1050}>
                          {tableData.length > 0 ? (
                            <Box>
                              <TableContainer>
                                <Table aria-label="caption table" size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Invoice Number</TableCell>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Ref Number </TableCell>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Supplier</TableCell>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Invoice Date</TableCell>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Invoice Amount (Rs.)</TableCell>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Paid Amount (Rs.)</TableCell>
                                      <TableCell align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>Outstanding (Rs.)</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                      <TableRow key={index}>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{row.voucherCode}</TableCell>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{row.invoiceReference}</TableCell>
                                        <TableCell align="center" style={{ border: '1px solid black' }}>{row.supplierName}</TableCell>
                                        <TableCell align="center" style={{ border: '1px solid black' }}>{row.createdDate ? row.createdDate.substring(0, 10) : ''}</TableCell>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{row.amount}</TableCell>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{row.paidAmount}</TableCell>
                                        <TableCell align="right" style={{ border: '1px solid black' }}>{row.remainingAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                                <TablePagination
                                  rowsPerPageOptions={[5, 10, 20]}
                                  component="div"
                                  count={tableData.length}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onChangePage={handleChangePage}
                                  onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                              </TableContainer>
                              <Box display="flex" justifyContent="flex-end" p={2}>
                                <Button
                                  color="primary"
                                  id="btnRecord"
                                  type="button"
                                  variant="contained"
                                  style={{ marginRight: '1rem' }}
                                  className={classes.colorRecord}
                                  onClick={createFile}
                                  size="small"
                                >
                                  EXCEL
                                </Button>
                                <ReactToPrint
                                  documentTitle={`${'Inovice Payment History Report' + ' - '}${groups[selectedSearchValues.groupID]} - ${factories[selectedSearchValues.factoryID]} - ${(new Date(selectedSearchValues.date)).toLocaleDateString()}`}
                                  trigger={() => (
                                    <Button
                                      color="primary"
                                      id="btnCancel"
                                      variant="contained"
                                      style={{ marginRight: '1rem' }}
                                      className={classes.colorCancel}
                                      size="small"
                                    >
                                      PDF
                                    </Button>
                                  )}
                                  pageStyle={getPageMargins()}
                                  content={() => componentRef.current}
                                />
                                <div hidden>
                                  <CreatePDF
                                    ref={componentRef}
                                    tableData={tableData}
                                    selectedSearchValues={{
                                      ...selectedSearchValues,
                                      groupName: groups[selectedSearchValues.groupID],
                                      factoryName: factories[selectedSearchValues.factoryID]
                                    }}
                                    TotalAmount={totalAmount}
                                  />
                                </div>
                              </Box>
                            </Box>
                          ) : null}
                        </Box>
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </>
  );
}
